import axios from "../../../../../../api/axiosInstance";
import { RefreshROIDashboardDataResponse } from "./types";

export const refreshROIDashboardData =
  async (): Promise<RefreshROIDashboardDataResponse> => {
    const response = await axios.post<RefreshROIDashboardDataResponse>(
      `/api/private/stochastic/roi-dashboard/refresh`,
    );

    return response.data;
  };
